<template>
  <div class="flex justify-center items-center">
    <div class="relative w-20 h-20">
      <div
        class="absolute inset-0 rounded-full dark:bg-sub-900 bg-main-800 opacity-60 animate-ping"
      ></div>
      <div
        class="absolute inset-1 rounded-full dark:bg-sub-900 bg-main-800 flex flex-col items-center justify-center p-1"
      >
        <svg
          version="1.2"
          baseProfile="tiny-ps"
          viewBox="0 0 300 300"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>hisell</title>
          <g>
            <g fill="#eeeeee" transform="matrix(.1 0 0 -.1 0 300)">
              <path
                d="M1925 2228c-11-6-26-18-32-26l-13-16v-34c0-18 4-42 10-52l10-18 34-12 35-11 37 10 36 10 14 18 13 18 1 32c0 45-9 62-41 78-33 18-76 19-104 3zm-942-8c-12-5-26-18-32-29l-11-20v-847l15-21 15-21 31-7 30-7 29 12 29 12 10 30 11 31v337l238-2 237-3 5-187 5-187 16-16 15-16 37-6 36-5 31 30 30 30v831l-11 25-12 25-32 11-33 11-26-7-26-6-15-21-15-21v-346h-480v317l-11 31-10 31-31 10c-36 13-45 13-75 1zm936-299-24-19-3-285-3-285 24-28 24-28h73l23 22 22 23 3 267c2 147 0 277-3 290-3 12-14 31-25 42l-20 20h-68l-23-19zM591 1041l-13-9 11-33c7-19 18-45 26-59l15-25-2 50-3 50 38 9c20 5 37 13 37 18v8h-47c-27 0-54-4-62-9zm1713 0c3-5 22-12 42-16l37-6-6-52-7-51 13 20c8 10 19 34 26 51l13 33-6 15-5 15h-112l5-9zM650 994c0-2 40-24 88-48 119-60 270-111 421-143l126-27h430l126 27c69 15 166 40 215 58 89 31 294 123 294 133 0 2-36-9-81-25-110-40-276-86-422-115l-122-25-167-6-166-6-124 18-123 17-150 38c-82 21-194 54-247 73-54 18-98 32-98 31z"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingComponent",
};
</script>
